import { createSelector } from 'reselect';
const configSelector = (state) => state?.config;

export const accertifyDataCollectorIsEnabledSelector = createSelector(
  configSelector,
  (config) => config?.universal?.accertifyDataCollector?.isEnabled
);
